import Consts from 'Framework/Consts';
import { HttpDeleteService, IHttpDeleteServiceProps } from 'Shared/HttpServices/Services/HttpDeleteService';
import { HttpGetService, IHttpGetServiceProps } from 'Shared/HttpServices/Services/HttpGetService';
import { HttpPostService, IHttpPostServiceProps } from 'Shared/HttpServices/Services/HttpPostService';
import { createAxiosHttpConfig } from 'Shared/HttpServices/Utils/utils';

const AggregatorHttpConfig = createAxiosHttpConfig({ baseURL: Consts.env.REACT_APP_AGGREGATOR_APP_BASE_URL });
export const AggregatorHttpGetService = async (props: IHttpGetServiceProps) =>
  HttpGetService({
    API: AggregatorHttpConfig,
    url: props.url,
    responseType: props.responseType,
    onResult: props.onResult,
    onError: props.onError,
    isFile: props.isFile,
    params: props.params,
  });

export const AggregatorHttpPostService = async (props: IHttpPostServiceProps) =>
  HttpPostService({
    API: AggregatorHttpConfig,
    url: props.url,
    body: props.body,
    onResult: props.onResult,
    onError: props.onError,
  });

export const AggregatorHttpDeleteService = async (props: IHttpDeleteServiceProps) =>
  HttpDeleteService({
    API: AggregatorHttpConfig,
    url: props.url,
    body: props.body,
    fromQuery: props.fromQuery,
    onResult: props.onResult,
    onError: props.onError,
  });
